import { Component, OnInit } from '@angular/core';
import { SuperClass } from '../../../../superclass/SuperClass';
import { BreadcrumbService } from '../../../../breadcrumb.service';
import { CookieService } from 'ngx-cookie-service';
import { DashboardDataService } from '../../../../services/dashboard-data.service';
import { ClientsService } from '../../../../services/clients/clients.service';
import { HttpClient } from '@angular/common/http';
import { WsService } from '../../../../services/websocket/WsService';
import { Country } from '../../vocabularies/countries/countries.model';
import { Globals } from '../../../../globals/Globals';
import { RouterConst } from '../../../../globals/RoutersConst';
import { HttpService } from '../../../../services/http.service'

@Component({
  selector: 'app-fonts-uploader',
  templateUrl: './fonts-uploader.component.html',
  styleUrls: ['./fonts-uploader.component.css'],
})
export class FontsUploaderComponent extends SuperClass implements OnInit {
  countries = [];
  selectedCountry: Country;

  logoImage = './../../../../../assets/img/placeholders/logo_placeholder-300x167.png?id=' +
  'randomParam';
  mainImage = '?id=' + 'randomParam';
  facebookIconImage = '?id=' + 'randomParam';
  twitterIconImage = '?id=' + 'randomParam';
  nextIconImage = '?id=' + 'randomParam';

  currImageTag;
  allFonts;
  files;
  form = {};

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
    private httpService: HttpService
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Organization' },
      { label: 'Captive Portal' },
      {
        label: 'Fonts Uploader',
        routerLink: [{ outlets: { sub: [RouterConst.FONTS_UPLOADER] } }],
      },
    ]);
  }

  ngOnInit() {
    this.httpService.get(Globals.SERVER_ADDR + '/cp/fonts/getAll').subscribe((data: any) => {
      this.allFonts = data.payload;
      console.log('Test', this.allFonts);
    });
  }

  addFont(event) {
    let target = event.target || event.srcElement;
    this.files = target.files;
    let final_data;
        if (this.files) {
            let files: FileList = this.files;
            const formData = new FormData();
            for (let i = 0; i < files.length; i++) {
                formData.append('font', files[i]);
            }
            formData.append('data', JSON.stringify(this.form));
            
            final_data = formData;
        } else {
            final_data = this.form;
    }
    this.httpService.post(Globals.SERVER_ADDR + '/cp/fonts/add', final_data).subscribe((resp: any)  => {
      this.allFonts = resp.payload; 
      console.log('test:', resp);
    })
}

  deletePhoto(id: string) {
    this.allFonts;
    this.httpService.post(Globals.SERVER_ADDR + '/cp/fonts/delete?id='+id, '').subscribe((data: any) => {
      if(data.payload == "SUCCESS") {
        this.httpService.get(Globals.SERVER_ADDR + '/cp/fonts/getAll').subscribe((data: any) => {
          this.allFonts = data.payload;
        });
      }
    });
  }

  toggleImages() {
    const clientId = this.cookiesService.get(Globals.COOKIES_CLIENT_ID);
    this.logoImage =
      Globals.SERVER_ADDR +
      '/cp/img/getByCpIdentifier?clientId=' +
      clientId +
      '&tag=LOGO&cpIdentifier=' +
      encodeURI(this.selectedCountry.name) +
      '&id=' +
      new Date().getMilliseconds();
    this.mainImage =
      Globals.SERVER_ADDR +
      '/cp/img/getByCpIdentifier?clientId=' +
      clientId +
      '&tag=LOGIN_IMAGE&cpIdentifier=' +
      encodeURI(this.selectedCountry.name) +
      '&id=' +
      new Date().getMilliseconds();
    this.facebookIconImage =
      Globals.SERVER_ADDR +
      '/cp/img/getByCpIdentifier?clientId=' +
      clientId +
      '&tag=CIRCLE_COLOR_FACEBOOK&cpIdentifier=' +
      encodeURI(this.selectedCountry.name) +
      '&id=' +
      new Date().getMilliseconds();
    this.twitterIconImage =
      Globals.SERVER_ADDR +
      '/cp/img/getByCpIdentifier?clientId=' +
      clientId +
      '&tag=CIRCLE_COLOR_TWITTER&cpIdentifier=' +
      encodeURI(this.selectedCountry.name) +
      '&id=' +
      new Date().getMilliseconds();
    this.nextIconImage =
      Globals.SERVER_ADDR +
      '/cp/img/getByCpIdentifier?clientId=' +
      clientId +
      '&tag=GREY_NAV_ARROW_MD&cpIdentifier=' +
      encodeURI(this.selectedCountry.name) +
      '&id=' +
      new Date().getMilliseconds();
  }

  imageEdit(nextIconImage: string) {
    this.currImageTag = nextIconImage;
    document.getElementById('image_loader_btn').click();
  }

  onChangeImage(e) {
    this.http_uploadImage(
      this.selectedCountry.name,
      this.currImageTag,
      e,
      (data: any) => {
        this.toggleImages();
      },
    );
  }

  chooseCountry(e) {
    this.toggleImages();
  }

  getWebSocketIdentifier(): string {
    return '';
  }

  reloadData(): void {
    this.http_getImagesCountries((data: any) => {
      this.countries = data.payload;
      this.selectedCountry = this.countries[0];
      this.toggleImages();
    });
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/captive-portal/fonts-uploader/fonts-uploader.component.ts